import defer from 'lodash/defer';
import { initObserveStore } from '../../../../ui-kitchen/src/utils/reduxUtils';
import { getResyLocationsBySlugThunk } from '../../../../ui-kitchen/src/reducers/resyLocationsSlice';
import { getSelectedCoreISODateThunk } from '../../../../ui-kitchen/src/reducers/resyCoreSlice';
import Logger from '../../../../ui-kitchen/src/utils/logger';

(() => {
  angular
    .module('resyApp')
    .controller('EventListingCtrl', EventListingCtrl);
})();

function EventListingCtrl($scope, $rootScope, $location, $routeParams, ResyEvents) {
  const PageCtrl = this;
  PageCtrl.selectedDate = null;
  PageCtrl.locationCode = null;
  PageCtrl.eventsByLocation = null;
  PageCtrl.gdaEventsByLocation = null;
  PageCtrl.containerQuery = $rootScope.matchMedia;

  const store = $rootScope.reduxStore;
  const { dispatch } = store;
  const onResyLocationsSliceChange = (resyLocations) => {
    const locationCode = resyLocations.selectedLocation?.code;
    if (locationCode && locationCode !== PageCtrl.locationCode) {
      PageCtrl.locationCode = locationCode;
      loadEventsByLocation();
      defer(() => $scope.$apply());
    }
  };
  const observeResyLocationsSlice = initObserveStore(store, ({ resyLocations }) => (resyLocations));
  const unsubscribeResyLocationsSlice = observeResyLocationsSlice(onResyLocationsSliceChange);

  const onResyCoreSliceChange = (resyCoreSlice) => {
    const { selectedCoreISODate } = resyCoreSlice;

    // SELECTED_DATE_UPDATED handling
    // PageCtrl.selectedDate is in ISO Date format
    if (PageCtrl.selectedDate !== selectedCoreISODate) {
      PageCtrl.selectedDate = selectedCoreISODate;
      loadEventsByLocation();
      defer(() => $scope.$apply());
    }
  };
  const observeResyCoreSlice = initObserveStore(store, ({ resyCore }) => (resyCore));
  const unsubscribeResyCoreSlice = observeResyCoreSlice(onResyCoreSliceChange);

  onInit();

  async function onInit() {
    setupReactors();

    await getLocation();
    loadDate();
    loadEventsByLocation();
  }

  function setupReactors() {
    $rootScope.$on('$destroy', () => {
      unsubscribeResyLocationsSlice();
      unsubscribeResyCoreSlice();
    });
  }

  async function getLocation() {
    if ($routeParams?.city) {
      const location = await dispatch(getResyLocationsBySlugThunk($routeParams?.city));
      if (location.show_on_web) {
        PageCtrl.locationCode = $routeParams.city;
        defer(() => $scope.$apply());
      } else {
        $location.path('/');
      }
    }
  }

  function loadDate() {
    PageCtrl.selectedDate = dispatch(getSelectedCoreISODateThunk());
    defer(() => $scope.$apply());
  }

  async function loadEventsByLocation() {
    if (PageCtrl.locationCode) {
      try {
        const gdaEventList = await ResyEvents.eventsByLocation({
          locationId: PageCtrl.locationCode, limit: 10, startDate: PageCtrl.selectedDate, filter_exclusive: 1000,
        });
        PageCtrl.gdaEventsByLocation = gdaEventList;
        defer(() => $scope.$apply());
      } catch (err) {
        Logger.error('[EventListing] error fetching gda events by location:', err);
      }

      try {
        const eventList = await ResyEvents.eventsByLocation({
          locationId: PageCtrl.locationCode, limit: 500, startDate: PageCtrl.selectedDate, filter_exclusive: -1000,
        });
        PageCtrl.eventsByLocation = eventList;
        defer(() => $scope.$apply());
      } catch (err) {
        Logger.error('[EventListing] error fetching events by location:', err);
      }
    }
  }
}

export default () => {};
